
import React, { useRef, useEffect, useState } from 'react'
import { Player } from '@lottiefiles/react-lottie-player'
import styles from './scrolling_infographic.module.sass'

import BlockWrapper from './layout/block_wrapper'

function ScrollingInfographic(props) {
	const fields = props.fields
	const container = useRef(null)
	const animationContainer = useRef(null)
	const player = useRef(null)
	const content = useRef(null)
  	const [lottie, setLottie] = useState(null)
	const [totalFrames, setTotalFrames] = useState(0)
	const [scroll, setScroll] = useState(0)
	const [contentHeight, setContentHeight] = useState(0)
	const [containerPosition, setContainerPosition] = useState(0)
	const [loaded, setLoaded] = useState(false)

	useEffect(() => {
		const onPageLoad = () => {
			setLoaded(true)
		}

		if (document.readyState === 'complete') {
			onPageLoad()
		} else {
			window.addEventListener('load', onPageLoad, false)
			return () => window.removeEventListener('load', onPageLoad)
		}
	}, [])

	useEffect(() => {
		const scrollHandler = () => {
			const scroll = window.scrollY
			setScroll(scroll)
		}
		
		const resizeHandler = () => {
			if(content.current){
				const contentHeight = content.current.clientHeight
				setContentHeight(contentHeight)
			}
		}

		window.addEventListener('scroll', scrollHandler)
		window.addEventListener('resize', resizeHandler)

		scrollHandler()
		resizeHandler()

		return () => {
			window.removeEventListener('scroll', scrollHandler)
			window.removeEventListener('resize', scrollHandler)
		}
	}, [contentHeight, totalFrames, loaded])

	useEffect(() => {
		if(lottie){
			lottie.setSubframe(false)
			setTotalFrames(lottie.totalFrames)
		}
	}, [lottie])

	useEffect(() => {
		if(content.current){
			const contentHeight = content.current.clientHeight
			setContentHeight(contentHeight)
		}
	}, [content, loaded])

	useEffect(() => {
		if(container.current){
			const containerPosition = container.current.getBoundingClientRect().top + window.scrollY
			setContainerPosition(containerPosition)
		}
	}, [container, loaded])

	useEffect(() => {
		const containerWidth = container.current.getBoundingClientRect().width;
		let translateXValue = (containerWidth - animationContainer.current.getBoundingClientRect().width) / 2 * -1;

		if(lottie){
			let currentFrame = (totalFrames/contentHeight)*(scroll-containerPosition)

			if(currentFrame > totalFrames){
				currentFrame = totalFrames
			}

			if(currentFrame < 0){
				currentFrame = 0
			}

			lottie.playSegments([currentFrame, currentFrame+1], true)
		}

		if(scroll > containerPosition){
			container.current.classList.add(styles.active)
			const after = window.getComputedStyle(content.current, ':after')
			const afterTop = (scroll-containerPosition) * -1 + (window.innerHeight - 141)
			
			animationContainer.current.style.transform = `translateX(0}px)`;

			if(((scroll-containerPosition) <= window.innerHeight)){
				animationContainer.current.style.transform = `translateX(0px)`;
				content.current.style.setProperty('--contentTop', `${afterTop}px`)
			} else {
				content.current.style.setProperty('--contentTop', `-50vh`)
				// animationContainer.current.style.transform = `translateX(0px)`;
			}
		} else {
			container.current.classList.remove(styles.active)

			if(scroll - containerPosition >= translateXValue){
				animationContainer.current.style.transform = `translateX(${0 + (scroll - containerPosition)}px)`
			} else {
				animationContainer.current.style.transform = `translateX(${translateXValue + 1}px)`
			}
		}
	}, [scroll, contentHeight, containerPosition, loaded, totalFrames])

	return <BlockWrapper {...props} className={styles.scrolling_infographic} >
		<div ref={container} className={styles.scrolling_wrapper}>
			<div ref={content} className={styles.content}>
				{fields.content_items.map((item, index) => {
					return <div key={index} className={styles.content_item}>
						<div className={styles.content_inner}>
							<h3>{item.title}</h3>
							<div dangerouslySetInnerHTML={{__html: item.content}} />
						</div>
					</div>
				})}
			</div>
			<div ref={animationContainer} className={styles.animation}>
				<div className={styles.lottie_wrapper}>
					<Player
						lottieRef={(data) => {
							setLottie(data)
						}}
						ref={player}
						loop={false} controls={false} src={fields.animation.url}
						rendererSettings={{className: styles.lottie_player}}
						style={{height: '100vh', width: '100%'}}
					/>
				</div>
			</div>
		</div>
	</BlockWrapper>

}

export default ScrollingInfographic